const ar = {
  welcomeMessage: 'Welcome aboard',
  home: 'Home',
  verificationServices: 'Verification Services',
  electronicServices: 'Electronic Services',
  furizatBillsVerification: 'Check Furizat Bills',
  error: 'Error',
  success: 'Success',
  dashboard: 'Dashboard',
  verificationServiceDescription: 'This service helps you to check Farjat initiative bills',
  docIdCopiedSuccessfully: 'Bill Number copied successfully',
  billNumber: 'Bill Number',
  billDetails: 'Bill Details',
  billDescription: 'Bill Description',
  validate: 'Verify',
  completionPercentage: 'Completion Percentage',
  remainingAmount: 'Remaining Amount',
  notCompeleted: 'not completed yet',
  compeleted: 'completed',
  rial: 'SAR',
  active: 'Active',
  back: 'Back',
  backToVerify: 'New Verify',
  backToVerificationServices: 'Back to verification services',
  donationViaEhsan: 'Donate via Ehsan Platform',
  billNumberPlaceholder: 'Example: 12534',
  noMatchingResultsTitle: 'There are no results matching the entered data',
  noMatchingResultsDescription: 'Please check the data and try again.',
  verificationSuccess: 'Verified successfully',

  validations: {
    onlyNumbers: 'Please enter numbers only',
    fieldIsRequired: 'This field is required',
    maxNumbersLength: 'Max numbers length {length}',
    furijatBillIsRequired: 'Please enter bill number',
  },

  serverErrors: {
    invoiceNotFound: 'Bill number {invoiceNumber} is not included in furijat initiative',
    USER_NOT_FOUND: 'User is not found, please try again',
    sometingWentWrong: 'Something went wrong , Please try again later ',
  },
};

export default ar;
